import {
  type BlocksContent,
  BlocksRenderer,
} from "@strapi/blocks-react-renderer";
import clsx from "clsx";

import { Body, Heading } from "@shared/ui/typography";
import { restoreRelativeUrl } from "@shared/utils";

import s from "./common-blocks-renderer.module.scss";

type Props = {
  data: BlocksContent;
};

export const CommonBlocksRenderer = (props: Props) => {
  const { data } = props;

  return (
    <BlocksRenderer
      content={data}
      blocks={{
        paragraph: ({ children }) => (
          <Body size="caption" className={s.text}>
            {children}
          </Body>
        ),
        link: ({ children, url }) => {
          const cleaned = restoreRelativeUrl(url);
          return (
            <a
              href={cleaned}
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(s.link, "global-link")}
            >
              {children}
            </a>
          );
        },
        list: ({ children, format }) => {
          switch (format) {
            case "unordered":
              return (
                <Body
                  size="caption"
                  tag="ul"
                  className={clsx(s.list, s.unordered)}
                >
                  {children}
                </Body>
              );
            case "ordered":
              return (
                <Body
                  size="caption"
                  tag="ol"
                  className={clsx(s.list, s.ordered)}
                >
                  {children}
                </Body>
              );
          }
        },
        heading: ({ children, level }) => (
          <Heading level={level}>{children}</Heading>
        ),
        code: ({ children }) => {
          // @ts-expect-error
          const child = children[0] || {};
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: child?.props?.text,
              }}
            />
          );
        },
      }}
      modifiers={{
        bold: ({ children }) => <strong> {children} </strong>,
      }}
    />
  );
};

CommonBlocksRenderer.displayName = "CommonBlocksRenderer";
